var map = {
	"./af-NA.mjs": [
		78224,
		[
			"src_assets_i18n_ng-locales_af-NA_mjs"
		]
	],
	"./af.mjs": [
		10562,
		[
			"src_assets_i18n_ng-locales_af_mjs"
		]
	],
	"./agq.mjs": [
		51528,
		[
			"src_assets_i18n_ng-locales_agq_mjs"
		]
	],
	"./ak.mjs": [
		90367,
		[
			"src_assets_i18n_ng-locales_ak_mjs"
		]
	],
	"./am.mjs": [
		63017,
		[
			"src_assets_i18n_ng-locales_am_mjs"
		]
	],
	"./ar-AE.mjs": [
		36033,
		[
			"src_assets_i18n_ng-locales_ar-AE_mjs"
		]
	],
	"./ar-BH.mjs": [
		59745,
		[
			"src_assets_i18n_ng-locales_ar-BH_mjs"
		]
	],
	"./ar-DJ.mjs": [
		25581,
		[
			"src_assets_i18n_ng-locales_ar-DJ_mjs"
		]
	],
	"./ar-DZ.mjs": [
		91613,
		[
			"src_assets_i18n_ng-locales_ar-DZ_mjs"
		]
	],
	"./ar-EG.mjs": [
		17287,
		[
			"src_assets_i18n_ng-locales_ar-EG_mjs"
		]
	],
	"./ar-EH.mjs": [
		33320,
		[
			"src_assets_i18n_ng-locales_ar-EH_mjs"
		]
	],
	"./ar-ER.mjs": [
		14290,
		[
			"src_assets_i18n_ng-locales_ar-ER_mjs"
		]
	],
	"./ar-IL.mjs": [
		87152,
		[
			"src_assets_i18n_ng-locales_ar-IL_mjs"
		]
	],
	"./ar-IQ.mjs": [
		89189,
		[
			"src_assets_i18n_ng-locales_ar-IQ_mjs"
		]
	],
	"./ar-JO.mjs": [
		96454,
		[
			"src_assets_i18n_ng-locales_ar-JO_mjs"
		]
	],
	"./ar-KM.mjs": [
		12543,
		[
			"src_assets_i18n_ng-locales_ar-KM_mjs"
		]
	],
	"./ar-KW.mjs": [
		70637,
		[
			"src_assets_i18n_ng-locales_ar-KW_mjs"
		]
	],
	"./ar-LB.mjs": [
		23053,
		[
			"src_assets_i18n_ng-locales_ar-LB_mjs"
		]
	],
	"./ar-LY.mjs": [
		12214,
		[
			"src_assets_i18n_ng-locales_ar-LY_mjs"
		]
	],
	"./ar-MA.mjs": [
		31545,
		[
			"src_assets_i18n_ng-locales_ar-MA_mjs"
		]
	],
	"./ar-MR.mjs": [
		36890,
		[
			"src_assets_i18n_ng-locales_ar-MR_mjs"
		]
	],
	"./ar-OM.mjs": [
		89371,
		[
			"src_assets_i18n_ng-locales_ar-OM_mjs"
		]
	],
	"./ar-PS.mjs": [
		88432,
		[
			"src_assets_i18n_ng-locales_ar-PS_mjs"
		]
	],
	"./ar-QA.mjs": [
		58525,
		[
			"src_assets_i18n_ng-locales_ar-QA_mjs"
		]
	],
	"./ar-SA.mjs": [
		78771,
		[
			"src_assets_i18n_ng-locales_ar-SA_mjs"
		]
	],
	"./ar-SD.mjs": [
		14566,
		[
			"src_assets_i18n_ng-locales_ar-SD_mjs"
		]
	],
	"./ar-SO.mjs": [
		53101,
		[
			"src_assets_i18n_ng-locales_ar-SO_mjs"
		]
	],
	"./ar-SS.mjs": [
		44361,
		[
			"src_assets_i18n_ng-locales_ar-SS_mjs"
		]
	],
	"./ar-SY.mjs": [
		74251,
		[
			"src_assets_i18n_ng-locales_ar-SY_mjs"
		]
	],
	"./ar-TD.mjs": [
		89251,
		[
			"src_assets_i18n_ng-locales_ar-TD_mjs"
		]
	],
	"./ar-TN.mjs": [
		10833,
		[
			"src_assets_i18n_ng-locales_ar-TN_mjs"
		]
	],
	"./ar-YE.mjs": [
		47513,
		[
			"src_assets_i18n_ng-locales_ar-YE_mjs"
		]
	],
	"./ar.mjs": [
		61614,
		[
			"src_assets_i18n_ng-locales_ar_mjs"
		]
	],
	"./as.mjs": [
		43543,
		[
			"src_assets_i18n_ng-locales_as_mjs"
		]
	],
	"./asa.mjs": [
		16140,
		[
			"src_assets_i18n_ng-locales_asa_mjs"
		]
	],
	"./ast.mjs": [
		59137,
		[
			"src_assets_i18n_ng-locales_ast_mjs"
		]
	],
	"./az-Cyrl.mjs": [
		60269,
		[
			"src_assets_i18n_ng-locales_az-Cyrl_mjs"
		]
	],
	"./az-Latn.mjs": [
		18724,
		[
			"src_assets_i18n_ng-locales_az-Latn_mjs"
		]
	],
	"./az.mjs": [
		49574,
		[
			"src_assets_i18n_ng-locales_az_mjs"
		]
	],
	"./bas.mjs": [
		53711,
		[
			"src_assets_i18n_ng-locales_bas_mjs"
		]
	],
	"./be-tarask.mjs": [
		24949,
		[
			"src_assets_i18n_ng-locales_be-tarask_mjs"
		]
	],
	"./be.mjs": [
		13540,
		[
			"src_assets_i18n_ng-locales_be_mjs"
		]
	],
	"./bem.mjs": [
		80013,
		[
			"src_assets_i18n_ng-locales_bem_mjs"
		]
	],
	"./bez.mjs": [
		54050,
		[
			"src_assets_i18n_ng-locales_bez_mjs"
		]
	],
	"./bg.mjs": [
		65718,
		[
			"src_assets_i18n_ng-locales_bg_mjs"
		]
	],
	"./bm.mjs": [
		91404,
		[
			"src_assets_i18n_ng-locales_bm_mjs"
		]
	],
	"./bn-IN.mjs": [
		48145,
		[
			"src_assets_i18n_ng-locales_bn-IN_mjs"
		]
	],
	"./bn.mjs": [
		18567,
		[
			"src_assets_i18n_ng-locales_bn_mjs"
		]
	],
	"./bo-IN.mjs": [
		37298,
		[
			"src_assets_i18n_ng-locales_bo-IN_mjs"
		]
	],
	"./bo.mjs": [
		60478,
		[
			"src_assets_i18n_ng-locales_bo_mjs"
		]
	],
	"./br.mjs": [
		95347,
		[
			"src_assets_i18n_ng-locales_br_mjs"
		]
	],
	"./brx.mjs": [
		62553,
		[
			"src_assets_i18n_ng-locales_brx_mjs"
		]
	],
	"./bs-Cyrl.mjs": [
		26057,
		[
			"src_assets_i18n_ng-locales_bs-Cyrl_mjs"
		]
	],
	"./bs-Latn.mjs": [
		98368,
		[
			"src_assets_i18n_ng-locales_bs-Latn_mjs"
		]
	],
	"./bs.mjs": [
		6186,
		[
			"src_assets_i18n_ng-locales_bs_mjs"
		]
	],
	"./ca-AD.mjs": [
		63,
		[
			"src_assets_i18n_ng-locales_ca-AD_mjs"
		]
	],
	"./ca-ES-valencia.mjs": [
		40692,
		[
			"src_assets_i18n_ng-locales_ca-ES-valencia_mjs"
		]
	],
	"./ca-FR.mjs": [
		75892,
		[
			"src_assets_i18n_ng-locales_ca-FR_mjs"
		]
	],
	"./ca-IT.mjs": [
		10695,
		[
			"src_assets_i18n_ng-locales_ca-IT_mjs"
		]
	],
	"./ca.mjs": [
		64115,
		[
			"src_assets_i18n_ng-locales_ca_mjs"
		]
	],
	"./ccp-IN.mjs": [
		29573,
		[
			"src_assets_i18n_ng-locales_ccp-IN_mjs"
		]
	],
	"./ccp.mjs": [
		15123,
		[
			"src_assets_i18n_ng-locales_ccp_mjs"
		]
	],
	"./ce.mjs": [
		12303,
		[
			"src_assets_i18n_ng-locales_ce_mjs"
		]
	],
	"./ceb.mjs": [
		17039,
		[
			"src_assets_i18n_ng-locales_ceb_mjs"
		]
	],
	"./cgg.mjs": [
		50800,
		[
			"src_assets_i18n_ng-locales_cgg_mjs"
		]
	],
	"./chr.mjs": [
		90056,
		[
			"src_assets_i18n_ng-locales_chr_mjs"
		]
	],
	"./ckb-IR.mjs": [
		50823,
		[
			"src_assets_i18n_ng-locales_ckb-IR_mjs"
		]
	],
	"./ckb.mjs": [
		65153,
		[
			"src_assets_i18n_ng-locales_ckb_mjs"
		]
	],
	"./cs.mjs": [
		3849,
		[
			"src_assets_i18n_ng-locales_cs_mjs"
		]
	],
	"./cy.mjs": [
		26411,
		[
			"src_assets_i18n_ng-locales_cy_mjs"
		]
	],
	"./da-GL.mjs": [
		70898,
		[
			"src_assets_i18n_ng-locales_da-GL_mjs"
		]
	],
	"./da.mjs": [
		64694,
		[
			"src_assets_i18n_ng-locales_da_mjs"
		]
	],
	"./dav.mjs": [
		58216,
		[
			"src_assets_i18n_ng-locales_dav_mjs"
		]
	],
	"./de-AT.mjs": [
		66020,
		[
			"src_assets_i18n_ng-locales_de-AT_mjs"
		]
	],
	"./de-BE.mjs": [
		74920,
		[
			"src_assets_i18n_ng-locales_de-BE_mjs"
		]
	],
	"./de-CH.mjs": [
		92078,
		[
			"src_assets_i18n_ng-locales_de-CH_mjs"
		]
	],
	"./de-IT.mjs": [
		14620,
		[
			"src_assets_i18n_ng-locales_de-IT_mjs"
		]
	],
	"./de-LI.mjs": [
		46298,
		[
			"src_assets_i18n_ng-locales_de-LI_mjs"
		]
	],
	"./de-LU.mjs": [
		45518,
		[
			"src_assets_i18n_ng-locales_de-LU_mjs"
		]
	],
	"./de.mjs": [
		19194,
		[
			"src_assets_i18n_ng-locales_de_mjs"
		]
	],
	"./dje.mjs": [
		80746,
		[
			"src_assets_i18n_ng-locales_dje_mjs"
		]
	],
	"./doi.mjs": [
		34085,
		[
			"src_assets_i18n_ng-locales_doi_mjs"
		]
	],
	"./dsb.mjs": [
		57914,
		[
			"src_assets_i18n_ng-locales_dsb_mjs"
		]
	],
	"./dua.mjs": [
		18715,
		[
			"src_assets_i18n_ng-locales_dua_mjs"
		]
	],
	"./dyo.mjs": [
		23417,
		[
			"src_assets_i18n_ng-locales_dyo_mjs"
		]
	],
	"./dz.mjs": [
		75533,
		[
			"src_assets_i18n_ng-locales_dz_mjs"
		]
	],
	"./ebu.mjs": [
		11039,
		[
			"src_assets_i18n_ng-locales_ebu_mjs"
		]
	],
	"./ee-TG.mjs": [
		44745,
		[
			"src_assets_i18n_ng-locales_ee-TG_mjs"
		]
	],
	"./ee.mjs": [
		27949,
		[
			"src_assets_i18n_ng-locales_ee_mjs"
		]
	],
	"./el-CY.mjs": [
		60801,
		[
			"src_assets_i18n_ng-locales_el-CY_mjs"
		]
	],
	"./el.mjs": [
		52372,
		[
			"src_assets_i18n_ng-locales_el_mjs"
		]
	],
	"./en-001.mjs": [
		96176,
		[
			"src_assets_i18n_ng-locales_en-001_mjs"
		]
	],
	"./en-150.mjs": [
		35667,
		[
			"src_assets_i18n_ng-locales_en-150_mjs"
		]
	],
	"./en-AE.mjs": [
		49753,
		[
			"src_assets_i18n_ng-locales_en-AE_mjs"
		]
	],
	"./en-AG.mjs": [
		90579,
		[
			"src_assets_i18n_ng-locales_en-AG_mjs"
		]
	],
	"./en-AI.mjs": [
		63853,
		[
			"src_assets_i18n_ng-locales_en-AI_mjs"
		]
	],
	"./en-AS.mjs": [
		54783,
		[
			"src_assets_i18n_ng-locales_en-AS_mjs"
		]
	],
	"./en-AT.mjs": [
		12872,
		[
			"src_assets_i18n_ng-locales_en-AT_mjs"
		]
	],
	"./en-AU.mjs": [
		585,
		[
			"src_assets_i18n_ng-locales_en-AU_mjs"
		]
	],
	"./en-BB.mjs": [
		28171,
		[
			"src_assets_i18n_ng-locales_en-BB_mjs"
		]
	],
	"./en-BE.mjs": [
		93996,
		[
			"src_assets_i18n_ng-locales_en-BE_mjs"
		]
	],
	"./en-BI.mjs": [
		6568,
		[
			"src_assets_i18n_ng-locales_en-BI_mjs"
		]
	],
	"./en-BM.mjs": [
		4804,
		[
			"src_assets_i18n_ng-locales_en-BM_mjs"
		]
	],
	"./en-BS.mjs": [
		11218,
		[
			"src_assets_i18n_ng-locales_en-BS_mjs"
		]
	],
	"./en-BW.mjs": [
		31054,
		[
			"src_assets_i18n_ng-locales_en-BW_mjs"
		]
	],
	"./en-BZ.mjs": [
		32691,
		[
			"src_assets_i18n_ng-locales_en-BZ_mjs"
		]
	],
	"./en-CA.mjs": [
		6459,
		[
			"src_assets_i18n_ng-locales_en-CA_mjs"
		]
	],
	"./en-CC.mjs": [
		20033,
		[
			"src_assets_i18n_ng-locales_en-CC_mjs"
		]
	],
	"./en-CH.mjs": [
		78154,
		[
			"src_assets_i18n_ng-locales_en-CH_mjs"
		]
	],
	"./en-CK.mjs": [
		98137,
		[
			"src_assets_i18n_ng-locales_en-CK_mjs"
		]
	],
	"./en-CM.mjs": [
		31855,
		[
			"src_assets_i18n_ng-locales_en-CM_mjs"
		]
	],
	"./en-CX.mjs": [
		67898,
		[
			"src_assets_i18n_ng-locales_en-CX_mjs"
		]
	],
	"./en-CY.mjs": [
		92227,
		[
			"src_assets_i18n_ng-locales_en-CY_mjs"
		]
	],
	"./en-DE.mjs": [
		7490,
		[
			"src_assets_i18n_ng-locales_en-DE_mjs"
		]
	],
	"./en-DG.mjs": [
		79728,
		[
			"src_assets_i18n_ng-locales_en-DG_mjs"
		]
	],
	"./en-DK.mjs": [
		35844,
		[
			"src_assets_i18n_ng-locales_en-DK_mjs"
		]
	],
	"./en-DM.mjs": [
		38074,
		[
			"src_assets_i18n_ng-locales_en-DM_mjs"
		]
	],
	"./en-ER.mjs": [
		26186,
		[
			"src_assets_i18n_ng-locales_en-ER_mjs"
		]
	],
	"./en-FI.mjs": [
		98236,
		[
			"src_assets_i18n_ng-locales_en-FI_mjs"
		]
	],
	"./en-FJ.mjs": [
		65847,
		[
			"src_assets_i18n_ng-locales_en-FJ_mjs"
		]
	],
	"./en-FK.mjs": [
		67566,
		[
			"src_assets_i18n_ng-locales_en-FK_mjs"
		]
	],
	"./en-FM.mjs": [
		12352,
		[
			"src_assets_i18n_ng-locales_en-FM_mjs"
		]
	],
	"./en-GB.mjs": [
		19940,
		[
			"src_assets_i18n_ng-locales_en-GB_mjs"
		]
	],
	"./en-GD.mjs": [
		95994,
		[
			"src_assets_i18n_ng-locales_en-GD_mjs"
		]
	],
	"./en-GG.mjs": [
		57833,
		[
			"src_assets_i18n_ng-locales_en-GG_mjs"
		]
	],
	"./en-GH.mjs": [
		96606,
		[
			"src_assets_i18n_ng-locales_en-GH_mjs"
		]
	],
	"./en-GI.mjs": [
		28519,
		[
			"src_assets_i18n_ng-locales_en-GI_mjs"
		]
	],
	"./en-GM.mjs": [
		14571,
		[
			"src_assets_i18n_ng-locales_en-GM_mjs"
		]
	],
	"./en-GU.mjs": [
		47827,
		[
			"src_assets_i18n_ng-locales_en-GU_mjs"
		]
	],
	"./en-GY.mjs": [
		84439,
		[
			"src_assets_i18n_ng-locales_en-GY_mjs"
		]
	],
	"./en-HK.mjs": [
		29624,
		[
			"src_assets_i18n_ng-locales_en-HK_mjs"
		]
	],
	"./en-IE.mjs": [
		6673,
		[
			"src_assets_i18n_ng-locales_en-IE_mjs"
		]
	],
	"./en-IL.mjs": [
		16232,
		[
			"src_assets_i18n_ng-locales_en-IL_mjs"
		]
	],
	"./en-IM.mjs": [
		38569,
		[
			"src_assets_i18n_ng-locales_en-IM_mjs"
		]
	],
	"./en-IN.mjs": [
		25146,
		[
			"src_assets_i18n_ng-locales_en-IN_mjs"
		]
	],
	"./en-IO.mjs": [
		49475,
		[
			"src_assets_i18n_ng-locales_en-IO_mjs"
		]
	],
	"./en-JE.mjs": [
		93092,
		[
			"src_assets_i18n_ng-locales_en-JE_mjs"
		]
	],
	"./en-JM.mjs": [
		54604,
		[
			"src_assets_i18n_ng-locales_en-JM_mjs"
		]
	],
	"./en-KE.mjs": [
		91855,
		[
			"src_assets_i18n_ng-locales_en-KE_mjs"
		]
	],
	"./en-KI.mjs": [
		58011,
		[
			"src_assets_i18n_ng-locales_en-KI_mjs"
		]
	],
	"./en-KN.mjs": [
		98876,
		[
			"src_assets_i18n_ng-locales_en-KN_mjs"
		]
	],
	"./en-KY.mjs": [
		89611,
		[
			"src_assets_i18n_ng-locales_en-KY_mjs"
		]
	],
	"./en-LC.mjs": [
		2116,
		[
			"src_assets_i18n_ng-locales_en-LC_mjs"
		]
	],
	"./en-LR.mjs": [
		45989,
		[
			"src_assets_i18n_ng-locales_en-LR_mjs"
		]
	],
	"./en-LS.mjs": [
		36084,
		[
			"src_assets_i18n_ng-locales_en-LS_mjs"
		]
	],
	"./en-MG.mjs": [
		75511,
		[
			"src_assets_i18n_ng-locales_en-MG_mjs"
		]
	],
	"./en-MH.mjs": [
		93400,
		[
			"src_assets_i18n_ng-locales_en-MH_mjs"
		]
	],
	"./en-MO.mjs": [
		52463,
		[
			"src_assets_i18n_ng-locales_en-MO_mjs"
		]
	],
	"./en-MP.mjs": [
		96976,
		[
			"src_assets_i18n_ng-locales_en-MP_mjs"
		]
	],
	"./en-MS.mjs": [
		24875,
		[
			"src_assets_i18n_ng-locales_en-MS_mjs"
		]
	],
	"./en-MT.mjs": [
		90700,
		[
			"src_assets_i18n_ng-locales_en-MT_mjs"
		]
	],
	"./en-MU.mjs": [
		12285,
		[
			"src_assets_i18n_ng-locales_en-MU_mjs"
		]
	],
	"./en-MV.mjs": [
		43998,
		[
			"src_assets_i18n_ng-locales_en-MV_mjs"
		]
	],
	"./en-MW.mjs": [
		87239,
		[
			"src_assets_i18n_ng-locales_en-MW_mjs"
		]
	],
	"./en-MY.mjs": [
		78633,
		[
			"src_assets_i18n_ng-locales_en-MY_mjs"
		]
	],
	"./en-NA.mjs": [
		84172,
		[
			"src_assets_i18n_ng-locales_en-NA_mjs"
		]
	],
	"./en-NF.mjs": [
		24235,
		[
			"src_assets_i18n_ng-locales_en-NF_mjs"
		]
	],
	"./en-NG.mjs": [
		28098,
		[
			"src_assets_i18n_ng-locales_en-NG_mjs"
		]
	],
	"./en-NL.mjs": [
		67497,
		[
			"src_assets_i18n_ng-locales_en-NL_mjs"
		]
	],
	"./en-NR.mjs": [
		94103,
		[
			"src_assets_i18n_ng-locales_en-NR_mjs"
		]
	],
	"./en-NU.mjs": [
		54560,
		[
			"src_assets_i18n_ng-locales_en-NU_mjs"
		]
	],
	"./en-NZ.mjs": [
		10127,
		[
			"src_assets_i18n_ng-locales_en-NZ_mjs"
		]
	],
	"./en-PG.mjs": [
		74004,
		[
			"src_assets_i18n_ng-locales_en-PG_mjs"
		]
	],
	"./en-PH.mjs": [
		71771,
		[
			"src_assets_i18n_ng-locales_en-PH_mjs"
		]
	],
	"./en-PK.mjs": [
		10400,
		[
			"src_assets_i18n_ng-locales_en-PK_mjs"
		]
	],
	"./en-PN.mjs": [
		40525,
		[
			"src_assets_i18n_ng-locales_en-PN_mjs"
		]
	],
	"./en-PR.mjs": [
		80809,
		[
			"src_assets_i18n_ng-locales_en-PR_mjs"
		]
	],
	"./en-PW.mjs": [
		59268,
		[
			"src_assets_i18n_ng-locales_en-PW_mjs"
		]
	],
	"./en-RW.mjs": [
		57758,
		[
			"src_assets_i18n_ng-locales_en-RW_mjs"
		]
	],
	"./en-SB.mjs": [
		37776,
		[
			"src_assets_i18n_ng-locales_en-SB_mjs"
		]
	],
	"./en-SC.mjs": [
		75217,
		[
			"src_assets_i18n_ng-locales_en-SC_mjs"
		]
	],
	"./en-SD.mjs": [
		20030,
		[
			"src_assets_i18n_ng-locales_en-SD_mjs"
		]
	],
	"./en-SE.mjs": [
		51943,
		[
			"src_assets_i18n_ng-locales_en-SE_mjs"
		]
	],
	"./en-SG.mjs": [
		83709,
		[
			"src_assets_i18n_ng-locales_en-SG_mjs"
		]
	],
	"./en-SH.mjs": [
		19418,
		[
			"src_assets_i18n_ng-locales_en-SH_mjs"
		]
	],
	"./en-SI.mjs": [
		53635,
		[
			"src_assets_i18n_ng-locales_en-SI_mjs"
		]
	],
	"./en-SL.mjs": [
		64918,
		[
			"src_assets_i18n_ng-locales_en-SL_mjs"
		]
	],
	"./en-SS.mjs": [
		24577,
		[
			"src_assets_i18n_ng-locales_en-SS_mjs"
		]
	],
	"./en-SX.mjs": [
		36010,
		[
			"src_assets_i18n_ng-locales_en-SX_mjs"
		]
	],
	"./en-SZ.mjs": [
		632,
		[
			"src_assets_i18n_ng-locales_en-SZ_mjs"
		]
	],
	"./en-TC.mjs": [
		75996,
		[
			"src_assets_i18n_ng-locales_en-TC_mjs"
		]
	],
	"./en-TK.mjs": [
		56596,
		[
			"src_assets_i18n_ng-locales_en-TK_mjs"
		]
	],
	"./en-TO.mjs": [
		69400,
		[
			"src_assets_i18n_ng-locales_en-TO_mjs"
		]
	],
	"./en-TT.mjs": [
		90411,
		[
			"src_assets_i18n_ng-locales_en-TT_mjs"
		]
	],
	"./en-TV.mjs": [
		27633,
		[
			"src_assets_i18n_ng-locales_en-TV_mjs"
		]
	],
	"./en-TZ.mjs": [
		40181,
		[
			"src_assets_i18n_ng-locales_en-TZ_mjs"
		]
	],
	"./en-UG.mjs": [
		12527,
		[
			"src_assets_i18n_ng-locales_en-UG_mjs"
		]
	],
	"./en-UM.mjs": [
		21261,
		[
			"src_assets_i18n_ng-locales_en-UM_mjs"
		]
	],
	"./en-VC.mjs": [
		68694,
		[
			"src_assets_i18n_ng-locales_en-VC_mjs"
		]
	],
	"./en-VG.mjs": [
		18746,
		[
			"src_assets_i18n_ng-locales_en-VG_mjs"
		]
	],
	"./en-VI.mjs": [
		78028,
		[
			"src_assets_i18n_ng-locales_en-VI_mjs"
		]
	],
	"./en-VU.mjs": [
		4408,
		[
			"src_assets_i18n_ng-locales_en-VU_mjs"
		]
	],
	"./en-WS.mjs": [
		39509,
		[
			"src_assets_i18n_ng-locales_en-WS_mjs"
		]
	],
	"./en-ZA.mjs": [
		10296,
		[
			"src_assets_i18n_ng-locales_en-ZA_mjs"
		]
	],
	"./en-ZM.mjs": [
		33244,
		[
			"src_assets_i18n_ng-locales_en-ZM_mjs"
		]
	],
	"./en-ZW.mjs": [
		74582,
		[
			"src_assets_i18n_ng-locales_en-ZW_mjs"
		]
	],
	"./en.mjs": [
		24614,
		[
			"src_assets_i18n_ng-locales_en_mjs"
		]
	],
	"./eo.mjs": [
		35567,
		[
			"src_assets_i18n_ng-locales_eo_mjs"
		]
	],
	"./es-419.mjs": [
		48890,
		[
			"src_assets_i18n_ng-locales_es-419_mjs"
		]
	],
	"./es-AR.mjs": [
		15089,
		[
			"src_assets_i18n_ng-locales_es-AR_mjs"
		]
	],
	"./es-BO.mjs": [
		59725,
		[
			"src_assets_i18n_ng-locales_es-BO_mjs"
		]
	],
	"./es-BR.mjs": [
		42920,
		[
			"src_assets_i18n_ng-locales_es-BR_mjs"
		]
	],
	"./es-BZ.mjs": [
		52976,
		[
			"src_assets_i18n_ng-locales_es-BZ_mjs"
		]
	],
	"./es-CL.mjs": [
		15869,
		[
			"src_assets_i18n_ng-locales_es-CL_mjs"
		]
	],
	"./es-CO.mjs": [
		31230,
		[
			"src_assets_i18n_ng-locales_es-CO_mjs"
		]
	],
	"./es-CR.mjs": [
		16627,
		[
			"src_assets_i18n_ng-locales_es-CR_mjs"
		]
	],
	"./es-CU.mjs": [
		92084,
		[
			"src_assets_i18n_ng-locales_es-CU_mjs"
		]
	],
	"./es-DO.mjs": [
		18543,
		[
			"src_assets_i18n_ng-locales_es-DO_mjs"
		]
	],
	"./es-EA.mjs": [
		7158,
		[
			"src_assets_i18n_ng-locales_es-EA_mjs"
		]
	],
	"./es-EC.mjs": [
		85604,
		[
			"src_assets_i18n_ng-locales_es-EC_mjs"
		]
	],
	"./es-GQ.mjs": [
		2876,
		[
			"src_assets_i18n_ng-locales_es-GQ_mjs"
		]
	],
	"./es-GT.mjs": [
		26593,
		[
			"src_assets_i18n_ng-locales_es-GT_mjs"
		]
	],
	"./es-HN.mjs": [
		19634,
		[
			"src_assets_i18n_ng-locales_es-HN_mjs"
		]
	],
	"./es-IC.mjs": [
		62568,
		[
			"src_assets_i18n_ng-locales_es-IC_mjs"
		]
	],
	"./es-MX.mjs": [
		98799,
		[
			"src_assets_i18n_ng-locales_es-MX_mjs"
		]
	],
	"./es-NI.mjs": [
		13671,
		[
			"src_assets_i18n_ng-locales_es-NI_mjs"
		]
	],
	"./es-PA.mjs": [
		46253,
		[
			"src_assets_i18n_ng-locales_es-PA_mjs"
		]
	],
	"./es-PE.mjs": [
		42657,
		[
			"src_assets_i18n_ng-locales_es-PE_mjs"
		]
	],
	"./es-PH.mjs": [
		5908,
		[
			"src_assets_i18n_ng-locales_es-PH_mjs"
		]
	],
	"./es-PR.mjs": [
		38110,
		[
			"src_assets_i18n_ng-locales_es-PR_mjs"
		]
	],
	"./es-PY.mjs": [
		89493,
		[
			"src_assets_i18n_ng-locales_es-PY_mjs"
		]
	],
	"./es-SV.mjs": [
		28831,
		[
			"src_assets_i18n_ng-locales_es-SV_mjs"
		]
	],
	"./es-US.mjs": [
		34596,
		[
			"src_assets_i18n_ng-locales_es-US_mjs"
		]
	],
	"./es-UY.mjs": [
		65182,
		[
			"src_assets_i18n_ng-locales_es-UY_mjs"
		]
	],
	"./es-VE.mjs": [
		13323,
		[
			"src_assets_i18n_ng-locales_es-VE_mjs"
		]
	],
	"./es.mjs": [
		84299,
		[
			"src_assets_i18n_ng-locales_es_mjs"
		]
	],
	"./et.mjs": [
		33772,
		[
			"src_assets_i18n_ng-locales_et_mjs"
		]
	],
	"./eu.mjs": [
		36509,
		[
			"src_assets_i18n_ng-locales_eu_mjs"
		]
	],
	"./ewo.mjs": [
		44682,
		[
			"src_assets_i18n_ng-locales_ewo_mjs"
		]
	],
	"./fa-AF.mjs": [
		43584,
		[
			"src_assets_i18n_ng-locales_fa-AF_mjs"
		]
	],
	"./fa.mjs": [
		4620,
		[
			"src_assets_i18n_ng-locales_fa_mjs"
		]
	],
	"./ff-Adlm-BF.mjs": [
		89679,
		[
			"src_assets_i18n_ng-locales_ff-Adlm-BF_mjs"
		]
	],
	"./ff-Adlm-CM.mjs": [
		98695,
		[
			"src_assets_i18n_ng-locales_ff-Adlm-CM_mjs"
		]
	],
	"./ff-Adlm-GH.mjs": [
		51734,
		[
			"src_assets_i18n_ng-locales_ff-Adlm-GH_mjs"
		]
	],
	"./ff-Adlm-GM.mjs": [
		40451,
		[
			"src_assets_i18n_ng-locales_ff-Adlm-GM_mjs"
		]
	],
	"./ff-Adlm-GW.mjs": [
		11393,
		[
			"src_assets_i18n_ng-locales_ff-Adlm-GW_mjs"
		]
	],
	"./ff-Adlm-LR.mjs": [
		49725,
		[
			"src_assets_i18n_ng-locales_ff-Adlm-LR_mjs"
		]
	],
	"./ff-Adlm-MR.mjs": [
		55002,
		[
			"src_assets_i18n_ng-locales_ff-Adlm-MR_mjs"
		]
	],
	"./ff-Adlm-NE.mjs": [
		41768,
		[
			"src_assets_i18n_ng-locales_ff-Adlm-NE_mjs"
		]
	],
	"./ff-Adlm-NG.mjs": [
		46234,
		[
			"src_assets_i18n_ng-locales_ff-Adlm-NG_mjs"
		]
	],
	"./ff-Adlm-SL.mjs": [
		44718,
		[
			"src_assets_i18n_ng-locales_ff-Adlm-SL_mjs"
		]
	],
	"./ff-Adlm-SN.mjs": [
		75388,
		[
			"src_assets_i18n_ng-locales_ff-Adlm-SN_mjs"
		]
	],
	"./ff-Adlm.mjs": [
		87182,
		[
			"src_assets_i18n_ng-locales_ff-Adlm_mjs"
		]
	],
	"./ff-CM.mjs": [
		17324,
		[
			"src_assets_i18n_ng-locales_ff-CM_mjs"
		]
	],
	"./ff-GN.mjs": [
		2595,
		[
			"src_assets_i18n_ng-locales_ff-GN_mjs"
		]
	],
	"./ff-Latn-BF.mjs": [
		91764,
		[
			"src_assets_i18n_ng-locales_ff-Latn-BF_mjs"
		]
	],
	"./ff-Latn-CM.mjs": [
		33100,
		[
			"src_assets_i18n_ng-locales_ff-Latn-CM_mjs"
		]
	],
	"./ff-Latn-GH.mjs": [
		91029,
		[
			"src_assets_i18n_ng-locales_ff-Latn-GH_mjs"
		]
	],
	"./ff-Latn-GM.mjs": [
		54280,
		[
			"src_assets_i18n_ng-locales_ff-Latn-GM_mjs"
		]
	],
	"./ff-Latn-GN.mjs": [
		87523,
		[
			"src_assets_i18n_ng-locales_ff-Latn-GN_mjs"
		]
	],
	"./ff-Latn-GW.mjs": [
		47602,
		[
			"src_assets_i18n_ng-locales_ff-Latn-GW_mjs"
		]
	],
	"./ff-Latn-LR.mjs": [
		682,
		[
			"src_assets_i18n_ng-locales_ff-Latn-LR_mjs"
		]
	],
	"./ff-Latn-MR.mjs": [
		22445,
		[
			"src_assets_i18n_ng-locales_ff-Latn-MR_mjs"
		]
	],
	"./ff-Latn-NE.mjs": [
		77859,
		[
			"src_assets_i18n_ng-locales_ff-Latn-NE_mjs"
		]
	],
	"./ff-Latn-NG.mjs": [
		32329,
		[
			"src_assets_i18n_ng-locales_ff-Latn-NG_mjs"
		]
	],
	"./ff-Latn-SL.mjs": [
		25133,
		[
			"src_assets_i18n_ng-locales_ff-Latn-SL_mjs"
		]
	],
	"./ff-Latn.mjs": [
		1227,
		[
			"src_assets_i18n_ng-locales_ff-Latn_mjs"
		]
	],
	"./ff-MR.mjs": [
		79821,
		[
			"src_assets_i18n_ng-locales_ff-MR_mjs"
		]
	],
	"./ff.mjs": [
		44683,
		[
			"src_assets_i18n_ng-locales_ff_mjs"
		]
	],
	"./fi.mjs": [
		66404,
		[
			"src_assets_i18n_ng-locales_fi_mjs"
		]
	],
	"./fil.mjs": [
		61020,
		[
			"src_assets_i18n_ng-locales_fil_mjs"
		]
	],
	"./fo-DK.mjs": [
		16192,
		[
			"src_assets_i18n_ng-locales_fo-DK_mjs"
		]
	],
	"./fo.mjs": [
		26106,
		[
			"src_assets_i18n_ng-locales_fo_mjs"
		]
	],
	"./fr-BE.mjs": [
		63059,
		[
			"src_assets_i18n_ng-locales_fr-BE_mjs"
		]
	],
	"./fr-BF.mjs": [
		85496,
		[
			"src_assets_i18n_ng-locales_fr-BF_mjs"
		]
	],
	"./fr-BI.mjs": [
		99671,
		[
			"src_assets_i18n_ng-locales_fr-BI_mjs"
		]
	],
	"./fr-BJ.mjs": [
		34620,
		[
			"src_assets_i18n_ng-locales_fr-BJ_mjs"
		]
	],
	"./fr-BL.mjs": [
		8402,
		[
			"src_assets_i18n_ng-locales_fr-BL_mjs"
		]
	],
	"./fr-CA.mjs": [
		28836,
		[
			"src_assets_i18n_ng-locales_fr-CA_mjs"
		]
	],
	"./fr-CD.mjs": [
		50377,
		[
			"src_assets_i18n_ng-locales_fr-CD_mjs"
		]
	],
	"./fr-CF.mjs": [
		95907,
		[
			"src_assets_i18n_ng-locales_fr-CF_mjs"
		]
	],
	"./fr-CG.mjs": [
		47418,
		[
			"src_assets_i18n_ng-locales_fr-CG_mjs"
		]
	],
	"./fr-CH.mjs": [
		92477,
		[
			"src_assets_i18n_ng-locales_fr-CH_mjs"
		]
	],
	"./fr-CI.mjs": [
		90348,
		[
			"src_assets_i18n_ng-locales_fr-CI_mjs"
		]
	],
	"./fr-CM.mjs": [
		72720,
		[
			"src_assets_i18n_ng-locales_fr-CM_mjs"
		]
	],
	"./fr-DJ.mjs": [
		17662,
		[
			"src_assets_i18n_ng-locales_fr-DJ_mjs"
		]
	],
	"./fr-DZ.mjs": [
		50894,
		[
			"src_assets_i18n_ng-locales_fr-DZ_mjs"
		]
	],
	"./fr-GA.mjs": [
		48096,
		[
			"src_assets_i18n_ng-locales_fr-GA_mjs"
		]
	],
	"./fr-GF.mjs": [
		1591,
		[
			"src_assets_i18n_ng-locales_fr-GF_mjs"
		]
	],
	"./fr-GN.mjs": [
		94895,
		[
			"src_assets_i18n_ng-locales_fr-GN_mjs"
		]
	],
	"./fr-GP.mjs": [
		85617,
		[
			"src_assets_i18n_ng-locales_fr-GP_mjs"
		]
	],
	"./fr-GQ.mjs": [
		23056,
		[
			"src_assets_i18n_ng-locales_fr-GQ_mjs"
		]
	],
	"./fr-HT.mjs": [
		91868,
		[
			"src_assets_i18n_ng-locales_fr-HT_mjs"
		]
	],
	"./fr-KM.mjs": [
		95160,
		[
			"src_assets_i18n_ng-locales_fr-KM_mjs"
		]
	],
	"./fr-LU.mjs": [
		95281,
		[
			"src_assets_i18n_ng-locales_fr-LU_mjs"
		]
	],
	"./fr-MA.mjs": [
		9506,
		[
			"src_assets_i18n_ng-locales_fr-MA_mjs"
		]
	],
	"./fr-MC.mjs": [
		80304,
		[
			"src_assets_i18n_ng-locales_fr-MC_mjs"
		]
	],
	"./fr-MF.mjs": [
		95613,
		[
			"src_assets_i18n_ng-locales_fr-MF_mjs"
		]
	],
	"./fr-MG.mjs": [
		74028,
		[
			"src_assets_i18n_ng-locales_fr-MG_mjs"
		]
	],
	"./fr-ML.mjs": [
		5663,
		[
			"src_assets_i18n_ng-locales_fr-ML_mjs"
		]
	],
	"./fr-MQ.mjs": [
		67570,
		[
			"src_assets_i18n_ng-locales_fr-MQ_mjs"
		]
	],
	"./fr-MR.mjs": [
		673,
		[
			"src_assets_i18n_ng-locales_fr-MR_mjs"
		]
	],
	"./fr-MU.mjs": [
		60558,
		[
			"src_assets_i18n_ng-locales_fr-MU_mjs"
		]
	],
	"./fr-NC.mjs": [
		31561,
		[
			"src_assets_i18n_ng-locales_fr-NC_mjs"
		]
	],
	"./fr-NE.mjs": [
		32735,
		[
			"src_assets_i18n_ng-locales_fr-NE_mjs"
		]
	],
	"./fr-PF.mjs": [
		50454,
		[
			"src_assets_i18n_ng-locales_fr-PF_mjs"
		]
	],
	"./fr-PM.mjs": [
		62525,
		[
			"src_assets_i18n_ng-locales_fr-PM_mjs"
		]
	],
	"./fr-RE.mjs": [
		42531,
		[
			"src_assets_i18n_ng-locales_fr-RE_mjs"
		]
	],
	"./fr-RW.mjs": [
		19321,
		[
			"src_assets_i18n_ng-locales_fr-RW_mjs"
		]
	],
	"./fr-SC.mjs": [
		67846,
		[
			"src_assets_i18n_ng-locales_fr-SC_mjs"
		]
	],
	"./fr-SN.mjs": [
		2875,
		[
			"src_assets_i18n_ng-locales_fr-SN_mjs"
		]
	],
	"./fr-SY.mjs": [
		93356,
		[
			"src_assets_i18n_ng-locales_fr-SY_mjs"
		]
	],
	"./fr-TD.mjs": [
		48632,
		[
			"src_assets_i18n_ng-locales_fr-TD_mjs"
		]
	],
	"./fr-TG.mjs": [
		2899,
		[
			"src_assets_i18n_ng-locales_fr-TG_mjs"
		]
	],
	"./fr-TN.mjs": [
		52690,
		[
			"src_assets_i18n_ng-locales_fr-TN_mjs"
		]
	],
	"./fr-VU.mjs": [
		12743,
		[
			"src_assets_i18n_ng-locales_fr-VU_mjs"
		]
	],
	"./fr-WF.mjs": [
		60327,
		[
			"src_assets_i18n_ng-locales_fr-WF_mjs"
		]
	],
	"./fr-YT.mjs": [
		89299,
		[
			"src_assets_i18n_ng-locales_fr-YT_mjs"
		]
	],
	"./fr.mjs": [
		14551,
		[
			"src_assets_i18n_ng-locales_fr_mjs"
		]
	],
	"./fur.mjs": [
		55950,
		[
			"src_assets_i18n_ng-locales_fur_mjs"
		]
	],
	"./fy.mjs": [
		10868,
		[
			"src_assets_i18n_ng-locales_fy_mjs"
		]
	],
	"./ga-GB.mjs": [
		23099,
		[
			"src_assets_i18n_ng-locales_ga-GB_mjs"
		]
	],
	"./ga.mjs": [
		66967,
		[
			"src_assets_i18n_ng-locales_ga_mjs"
		]
	],
	"./gd.mjs": [
		80146,
		[
			"src_assets_i18n_ng-locales_gd_mjs"
		]
	],
	"./gl.mjs": [
		11466,
		[
			"src_assets_i18n_ng-locales_gl_mjs"
		]
	],
	"./gsw-FR.mjs": [
		30101,
		[
			"src_assets_i18n_ng-locales_gsw-FR_mjs"
		]
	],
	"./gsw-LI.mjs": [
		42636,
		[
			"src_assets_i18n_ng-locales_gsw-LI_mjs"
		]
	],
	"./gsw.mjs": [
		74984,
		[
			"src_assets_i18n_ng-locales_gsw_mjs"
		]
	],
	"./gu.mjs": [
		97099,
		[
			"src_assets_i18n_ng-locales_gu_mjs"
		]
	],
	"./guz.mjs": [
		90283,
		[
			"src_assets_i18n_ng-locales_guz_mjs"
		]
	],
	"./gv.mjs": [
		96880,
		[
			"src_assets_i18n_ng-locales_gv_mjs"
		]
	],
	"./ha-GH.mjs": [
		74682,
		[
			"src_assets_i18n_ng-locales_ha-GH_mjs"
		]
	],
	"./ha-NE.mjs": [
		48756,
		[
			"src_assets_i18n_ng-locales_ha-NE_mjs"
		]
	],
	"./ha.mjs": [
		6778,
		[
			"src_assets_i18n_ng-locales_ha_mjs"
		]
	],
	"./haw.mjs": [
		82509,
		[
			"src_assets_i18n_ng-locales_haw_mjs"
		]
	],
	"./he.mjs": [
		52278,
		[
			"src_assets_i18n_ng-locales_he_mjs"
		]
	],
	"./hi-Latn.mjs": [
		53976,
		[
			"src_assets_i18n_ng-locales_hi-Latn_mjs"
		]
	],
	"./hi.mjs": [
		29218,
		[
			"src_assets_i18n_ng-locales_hi_mjs"
		]
	],
	"./hr-BA.mjs": [
		32497,
		[
			"src_assets_i18n_ng-locales_hr-BA_mjs"
		]
	],
	"./hr.mjs": [
		17785,
		[
			"src_assets_i18n_ng-locales_hr_mjs"
		]
	],
	"./hsb.mjs": [
		98502,
		[
			"src_assets_i18n_ng-locales_hsb_mjs"
		]
	],
	"./hu.mjs": [
		82022,
		[
			"src_assets_i18n_ng-locales_hu_mjs"
		]
	],
	"./hy.mjs": [
		86021,
		[
			"src_assets_i18n_ng-locales_hy_mjs"
		]
	],
	"./ia.mjs": [
		95941,
		[
			"src_assets_i18n_ng-locales_ia_mjs"
		]
	],
	"./id.mjs": [
		56760,
		[
			"src_assets_i18n_ng-locales_id_mjs"
		]
	],
	"./ig.mjs": [
		27379,
		[
			"src_assets_i18n_ng-locales_ig_mjs"
		]
	],
	"./ii.mjs": [
		84301,
		[
			"src_assets_i18n_ng-locales_ii_mjs"
		]
	],
	"./is.mjs": [
		91583,
		[
			"src_assets_i18n_ng-locales_is_mjs"
		]
	],
	"./it-CH.mjs": [
		49844,
		[
			"src_assets_i18n_ng-locales_it-CH_mjs"
		]
	],
	"./it-SM.mjs": [
		50633,
		[
			"src_assets_i18n_ng-locales_it-SM_mjs"
		]
	],
	"./it-VA.mjs": [
		34742,
		[
			"src_assets_i18n_ng-locales_it-VA_mjs"
		]
	],
	"./it.mjs": [
		49672,
		[
			"src_assets_i18n_ng-locales_it_mjs"
		]
	],
	"./ja.mjs": [
		55344,
		[
			"src_assets_i18n_ng-locales_ja_mjs"
		]
	],
	"./jgo.mjs": [
		15337,
		[
			"src_assets_i18n_ng-locales_jgo_mjs"
		]
	],
	"./jmc.mjs": [
		86835,
		[
			"src_assets_i18n_ng-locales_jmc_mjs"
		]
	],
	"./jv.mjs": [
		33879,
		[
			"src_assets_i18n_ng-locales_jv_mjs"
		]
	],
	"./ka.mjs": [
		27355,
		[
			"src_assets_i18n_ng-locales_ka_mjs"
		]
	],
	"./kab.mjs": [
		80931,
		[
			"src_assets_i18n_ng-locales_kab_mjs"
		]
	],
	"./kam.mjs": [
		75372,
		[
			"src_assets_i18n_ng-locales_kam_mjs"
		]
	],
	"./kde.mjs": [
		89115,
		[
			"src_assets_i18n_ng-locales_kde_mjs"
		]
	],
	"./kea.mjs": [
		4940,
		[
			"src_assets_i18n_ng-locales_kea_mjs"
		]
	],
	"./kgp.mjs": [
		67119,
		[
			"src_assets_i18n_ng-locales_kgp_mjs"
		]
	],
	"./khq.mjs": [
		35979,
		[
			"src_assets_i18n_ng-locales_khq_mjs"
		]
	],
	"./ki.mjs": [
		40179,
		[
			"src_assets_i18n_ng-locales_ki_mjs"
		]
	],
	"./kk.mjs": [
		45881,
		[
			"src_assets_i18n_ng-locales_kk_mjs"
		]
	],
	"./kkj.mjs": [
		62897,
		[
			"src_assets_i18n_ng-locales_kkj_mjs"
		]
	],
	"./kl.mjs": [
		92326,
		[
			"src_assets_i18n_ng-locales_kl_mjs"
		]
	],
	"./kln.mjs": [
		18768,
		[
			"src_assets_i18n_ng-locales_kln_mjs"
		]
	],
	"./km.mjs": [
		79599,
		[
			"src_assets_i18n_ng-locales_km_mjs"
		]
	],
	"./kn.mjs": [
		15636,
		[
			"src_assets_i18n_ng-locales_kn_mjs"
		]
	],
	"./ko-KP.mjs": [
		24771,
		[
			"src_assets_i18n_ng-locales_ko-KP_mjs"
		]
	],
	"./ko.mjs": [
		9189,
		[
			"src_assets_i18n_ng-locales_ko_mjs"
		]
	],
	"./kok.mjs": [
		56612,
		[
			"src_assets_i18n_ng-locales_kok_mjs"
		]
	],
	"./ks-Arab.mjs": [
		1034,
		[
			"src_assets_i18n_ng-locales_ks-Arab_mjs"
		]
	],
	"./ks-Deva.mjs": [
		33704,
		[
			"src_assets_i18n_ng-locales_ks-Deva_mjs"
		]
	],
	"./ks.mjs": [
		70321,
		[
			"src_assets_i18n_ng-locales_ks_mjs"
		]
	],
	"./ksb.mjs": [
		24465,
		[
			"src_assets_i18n_ng-locales_ksb_mjs"
		]
	],
	"./ksf.mjs": [
		7837,
		[
			"src_assets_i18n_ng-locales_ksf_mjs"
		]
	],
	"./ksh.mjs": [
		50915,
		[
			"src_assets_i18n_ng-locales_ksh_mjs"
		]
	],
	"./ku.mjs": [
		98023,
		[
			"src_assets_i18n_ng-locales_ku_mjs"
		]
	],
	"./kw.mjs": [
		39421,
		[
			"src_assets_i18n_ng-locales_kw_mjs"
		]
	],
	"./ky.mjs": [
		16675,
		[
			"src_assets_i18n_ng-locales_ky_mjs"
		]
	],
	"./lag.mjs": [
		80465,
		[
			"src_assets_i18n_ng-locales_lag_mjs"
		]
	],
	"./lb.mjs": [
		19933,
		[
			"src_assets_i18n_ng-locales_lb_mjs"
		]
	],
	"./lg.mjs": [
		176,
		[
			"src_assets_i18n_ng-locales_lg_mjs"
		]
	],
	"./lkt.mjs": [
		54852,
		[
			"src_assets_i18n_ng-locales_lkt_mjs"
		]
	],
	"./ln-AO.mjs": [
		84666,
		[
			"src_assets_i18n_ng-locales_ln-AO_mjs"
		]
	],
	"./ln-CF.mjs": [
		43977,
		[
			"src_assets_i18n_ng-locales_ln-CF_mjs"
		]
	],
	"./ln-CG.mjs": [
		56264,
		[
			"src_assets_i18n_ng-locales_ln-CG_mjs"
		]
	],
	"./ln.mjs": [
		94185,
		[
			"src_assets_i18n_ng-locales_ln_mjs"
		]
	],
	"./lo.mjs": [
		6472,
		[
			"src_assets_i18n_ng-locales_lo_mjs"
		]
	],
	"./lrc-IQ.mjs": [
		14647,
		[
			"src_assets_i18n_ng-locales_lrc-IQ_mjs"
		]
	],
	"./lrc.mjs": [
		31876,
		[
			"src_assets_i18n_ng-locales_lrc_mjs"
		]
	],
	"./lt.mjs": [
		68795,
		[
			"src_assets_i18n_ng-locales_lt_mjs"
		]
	],
	"./lu.mjs": [
		83442,
		[
			"src_assets_i18n_ng-locales_lu_mjs"
		]
	],
	"./luo.mjs": [
		93421,
		[
			"src_assets_i18n_ng-locales_luo_mjs"
		]
	],
	"./luy.mjs": [
		49771,
		[
			"src_assets_i18n_ng-locales_luy_mjs"
		]
	],
	"./lv.mjs": [
		68129,
		[
			"src_assets_i18n_ng-locales_lv_mjs"
		]
	],
	"./mai.mjs": [
		97810,
		[
			"src_assets_i18n_ng-locales_mai_mjs"
		]
	],
	"./mas-TZ.mjs": [
		62447,
		[
			"src_assets_i18n_ng-locales_mas-TZ_mjs"
		]
	],
	"./mas.mjs": [
		86664,
		[
			"src_assets_i18n_ng-locales_mas_mjs"
		]
	],
	"./mer.mjs": [
		9341,
		[
			"src_assets_i18n_ng-locales_mer_mjs"
		]
	],
	"./mfe.mjs": [
		74035,
		[
			"src_assets_i18n_ng-locales_mfe_mjs"
		]
	],
	"./mg.mjs": [
		7775,
		[
			"src_assets_i18n_ng-locales_mg_mjs"
		]
	],
	"./mgh.mjs": [
		34077,
		[
			"src_assets_i18n_ng-locales_mgh_mjs"
		]
	],
	"./mgo.mjs": [
		92226,
		[
			"src_assets_i18n_ng-locales_mgo_mjs"
		]
	],
	"./mi.mjs": [
		91057,
		[
			"src_assets_i18n_ng-locales_mi_mjs"
		]
	],
	"./mk.mjs": [
		5867,
		[
			"src_assets_i18n_ng-locales_mk_mjs"
		]
	],
	"./ml.mjs": [
		71692,
		[
			"src_assets_i18n_ng-locales_ml_mjs"
		]
	],
	"./mn.mjs": [
		6142,
		[
			"src_assets_i18n_ng-locales_mn_mjs"
		]
	],
	"./mni-Beng.mjs": [
		94578,
		[
			"src_assets_i18n_ng-locales_mni-Beng_mjs"
		]
	],
	"./mni.mjs": [
		53375,
		[
			"src_assets_i18n_ng-locales_mni_mjs"
		]
	],
	"./mr.mjs": [
		19786,
		[
			"src_assets_i18n_ng-locales_mr_mjs"
		]
	],
	"./ms-BN.mjs": [
		31860,
		[
			"src_assets_i18n_ng-locales_ms-BN_mjs"
		]
	],
	"./ms-ID.mjs": [
		16951,
		[
			"src_assets_i18n_ng-locales_ms-ID_mjs"
		]
	],
	"./ms-SG.mjs": [
		17166,
		[
			"src_assets_i18n_ng-locales_ms-SG_mjs"
		]
	],
	"./ms.mjs": [
		26739,
		[
			"src_assets_i18n_ng-locales_ms_mjs"
		]
	],
	"./mt.mjs": [
		73940,
		[
			"src_assets_i18n_ng-locales_mt_mjs"
		]
	],
	"./mua.mjs": [
		89726,
		[
			"src_assets_i18n_ng-locales_mua_mjs"
		]
	],
	"./my.mjs": [
		45313,
		[
			"src_assets_i18n_ng-locales_my_mjs"
		]
	],
	"./mzn.mjs": [
		2940,
		[
			"src_assets_i18n_ng-locales_mzn_mjs"
		]
	],
	"./naq.mjs": [
		41369,
		[
			"src_assets_i18n_ng-locales_naq_mjs"
		]
	],
	"./nb-SJ.mjs": [
		22207,
		[
			"src_assets_i18n_ng-locales_nb-SJ_mjs"
		]
	],
	"./nb.mjs": [
		25903,
		[
			"src_assets_i18n_ng-locales_nb_mjs"
		]
	],
	"./nd.mjs": [
		75833,
		[
			"src_assets_i18n_ng-locales_nd_mjs"
		]
	],
	"./nds-NL.mjs": [
		11811,
		[
			"src_assets_i18n_ng-locales_nds-NL_mjs"
		]
	],
	"./nds.mjs": [
		98776,
		[
			"src_assets_i18n_ng-locales_nds_mjs"
		]
	],
	"./ne-IN.mjs": [
		45908,
		[
			"src_assets_i18n_ng-locales_ne-IN_mjs"
		]
	],
	"./ne.mjs": [
		66840,
		[
			"src_assets_i18n_ng-locales_ne_mjs"
		]
	],
	"./nl-AW.mjs": [
		4138,
		[
			"src_assets_i18n_ng-locales_nl-AW_mjs"
		]
	],
	"./nl-BE.mjs": [
		63941,
		[
			"src_assets_i18n_ng-locales_nl-BE_mjs"
		]
	],
	"./nl-BQ.mjs": [
		56969,
		[
			"src_assets_i18n_ng-locales_nl-BQ_mjs"
		]
	],
	"./nl-CW.mjs": [
		85168,
		[
			"src_assets_i18n_ng-locales_nl-CW_mjs"
		]
	],
	"./nl-SR.mjs": [
		12077,
		[
			"src_assets_i18n_ng-locales_nl-SR_mjs"
		]
	],
	"./nl-SX.mjs": [
		77167,
		[
			"src_assets_i18n_ng-locales_nl-SX_mjs"
		]
	],
	"./nl.mjs": [
		97729,
		[
			"src_assets_i18n_ng-locales_nl_mjs"
		]
	],
	"./nmg.mjs": [
		22539,
		[
			"src_assets_i18n_ng-locales_nmg_mjs"
		]
	],
	"./nn.mjs": [
		84155,
		[
			"src_assets_i18n_ng-locales_nn_mjs"
		]
	],
	"./nnh.mjs": [
		20145,
		[
			"src_assets_i18n_ng-locales_nnh_mjs"
		]
	],
	"./no.mjs": [
		41330,
		[
			"src_assets_i18n_ng-locales_no_mjs"
		]
	],
	"./nus.mjs": [
		98511,
		[
			"src_assets_i18n_ng-locales_nus_mjs"
		]
	],
	"./nyn.mjs": [
		59286,
		[
			"src_assets_i18n_ng-locales_nyn_mjs"
		]
	],
	"./om-KE.mjs": [
		63212,
		[
			"src_assets_i18n_ng-locales_om-KE_mjs"
		]
	],
	"./om.mjs": [
		35019,
		[
			"src_assets_i18n_ng-locales_om_mjs"
		]
	],
	"./or.mjs": [
		1204,
		[
			"src_assets_i18n_ng-locales_or_mjs"
		]
	],
	"./os-RU.mjs": [
		77473,
		[
			"src_assets_i18n_ng-locales_os-RU_mjs"
		]
	],
	"./os.mjs": [
		53189,
		[
			"src_assets_i18n_ng-locales_os_mjs"
		]
	],
	"./pa-Arab.mjs": [
		12155,
		[
			"src_assets_i18n_ng-locales_pa-Arab_mjs"
		]
	],
	"./pa-Guru.mjs": [
		72744,
		[
			"src_assets_i18n_ng-locales_pa-Guru_mjs"
		]
	],
	"./pa.mjs": [
		56610,
		[
			"src_assets_i18n_ng-locales_pa_mjs"
		]
	],
	"./pcm.mjs": [
		3097,
		[
			"src_assets_i18n_ng-locales_pcm_mjs"
		]
	],
	"./pl.mjs": [
		40863,
		[
			"src_assets_i18n_ng-locales_pl_mjs"
		]
	],
	"./ps-PK.mjs": [
		71466,
		[
			"src_assets_i18n_ng-locales_ps-PK_mjs"
		]
	],
	"./ps.mjs": [
		83072,
		[
			"src_assets_i18n_ng-locales_ps_mjs"
		]
	],
	"./pt-AO.mjs": [
		63672,
		[
			"src_assets_i18n_ng-locales_pt-AO_mjs"
		]
	],
	"./pt-CH.mjs": [
		41085,
		[
			"src_assets_i18n_ng-locales_pt-CH_mjs"
		]
	],
	"./pt-CV.mjs": [
		41843,
		[
			"src_assets_i18n_ng-locales_pt-CV_mjs"
		]
	],
	"./pt-GQ.mjs": [
		31632,
		[
			"src_assets_i18n_ng-locales_pt-GQ_mjs"
		]
	],
	"./pt-GW.mjs": [
		30238,
		[
			"src_assets_i18n_ng-locales_pt-GW_mjs"
		]
	],
	"./pt-LU.mjs": [
		78737,
		[
			"src_assets_i18n_ng-locales_pt-LU_mjs"
		]
	],
	"./pt-MO.mjs": [
		10820,
		[
			"src_assets_i18n_ng-locales_pt-MO_mjs"
		]
	],
	"./pt-MZ.mjs": [
		81529,
		[
			"src_assets_i18n_ng-locales_pt-MZ_mjs"
		]
	],
	"./pt-PT.mjs": [
		22196,
		[
			"src_assets_i18n_ng-locales_pt-PT_mjs"
		]
	],
	"./pt-ST.mjs": [
		51689,
		[
			"src_assets_i18n_ng-locales_pt-ST_mjs"
		]
	],
	"./pt-TL.mjs": [
		66144,
		[
			"src_assets_i18n_ng-locales_pt-TL_mjs"
		]
	],
	"./pt.mjs": [
		82647,
		[
			"src_assets_i18n_ng-locales_pt_mjs"
		]
	],
	"./qu-BO.mjs": [
		42695,
		[
			"src_assets_i18n_ng-locales_qu-BO_mjs"
		]
	],
	"./qu-EC.mjs": [
		63010,
		[
			"src_assets_i18n_ng-locales_qu-EC_mjs"
		]
	],
	"./qu.mjs": [
		76561,
		[
			"src_assets_i18n_ng-locales_qu_mjs"
		]
	],
	"./rm.mjs": [
		53692,
		[
			"src_assets_i18n_ng-locales_rm_mjs"
		]
	],
	"./rn.mjs": [
		37975,
		[
			"src_assets_i18n_ng-locales_rn_mjs"
		]
	],
	"./ro-MD.mjs": [
		90900,
		[
			"src_assets_i18n_ng-locales_ro-MD_mjs"
		]
	],
	"./ro.mjs": [
		88398,
		[
			"src_assets_i18n_ng-locales_ro_mjs"
		]
	],
	"./rof.mjs": [
		77728,
		[
			"src_assets_i18n_ng-locales_rof_mjs"
		]
	],
	"./ru-BY.mjs": [
		80438,
		[
			"src_assets_i18n_ng-locales_ru-BY_mjs"
		]
	],
	"./ru-KG.mjs": [
		21159,
		[
			"src_assets_i18n_ng-locales_ru-KG_mjs"
		]
	],
	"./ru-KZ.mjs": [
		98890,
		[
			"src_assets_i18n_ng-locales_ru-KZ_mjs"
		]
	],
	"./ru-MD.mjs": [
		4982,
		[
			"src_assets_i18n_ng-locales_ru-MD_mjs"
		]
	],
	"./ru-UA.mjs": [
		15483,
		[
			"src_assets_i18n_ng-locales_ru-UA_mjs"
		]
	],
	"./ru.mjs": [
		89828,
		[
			"src_assets_i18n_ng-locales_ru_mjs"
		]
	],
	"./rw.mjs": [
		11382,
		[
			"src_assets_i18n_ng-locales_rw_mjs"
		]
	],
	"./rwk.mjs": [
		60845,
		[
			"src_assets_i18n_ng-locales_rwk_mjs"
		]
	],
	"./sa.mjs": [
		38243,
		[
			"src_assets_i18n_ng-locales_sa_mjs"
		]
	],
	"./sah.mjs": [
		3353,
		[
			"src_assets_i18n_ng-locales_sah_mjs"
		]
	],
	"./saq.mjs": [
		50960,
		[
			"src_assets_i18n_ng-locales_saq_mjs"
		]
	],
	"./sat-Olck.mjs": [
		43353,
		[
			"src_assets_i18n_ng-locales_sat-Olck_mjs"
		]
	],
	"./sat.mjs": [
		54365,
		[
			"src_assets_i18n_ng-locales_sat_mjs"
		]
	],
	"./sbp.mjs": [
		1460,
		[
			"src_assets_i18n_ng-locales_sbp_mjs"
		]
	],
	"./sc.mjs": [
		43689,
		[
			"src_assets_i18n_ng-locales_sc_mjs"
		]
	],
	"./sd-Arab.mjs": [
		62559,
		[
			"src_assets_i18n_ng-locales_sd-Arab_mjs"
		]
	],
	"./sd-Deva.mjs": [
		59577,
		[
			"src_assets_i18n_ng-locales_sd-Deva_mjs"
		]
	],
	"./sd.mjs": [
		48918,
		[
			"src_assets_i18n_ng-locales_sd_mjs"
		]
	],
	"./se-FI.mjs": [
		8571,
		[
			"src_assets_i18n_ng-locales_se-FI_mjs"
		]
	],
	"./se-SE.mjs": [
		47104,
		[
			"src_assets_i18n_ng-locales_se-SE_mjs"
		]
	],
	"./se.mjs": [
		71039,
		[
			"src_assets_i18n_ng-locales_se_mjs"
		]
	],
	"./seh.mjs": [
		4701,
		[
			"src_assets_i18n_ng-locales_seh_mjs"
		]
	],
	"./ses.mjs": [
		72454,
		[
			"src_assets_i18n_ng-locales_ses_mjs"
		]
	],
	"./sg.mjs": [
		23349,
		[
			"src_assets_i18n_ng-locales_sg_mjs"
		]
	],
	"./shi-Latn.mjs": [
		19147,
		[
			"src_assets_i18n_ng-locales_shi-Latn_mjs"
		]
	],
	"./shi-Tfng.mjs": [
		83043,
		[
			"src_assets_i18n_ng-locales_shi-Tfng_mjs"
		]
	],
	"./shi.mjs": [
		77675,
		[
			"src_assets_i18n_ng-locales_shi_mjs"
		]
	],
	"./si.mjs": [
		73579,
		[
			"src_assets_i18n_ng-locales_si_mjs"
		]
	],
	"./sk.mjs": [
		8241,
		[
			"src_assets_i18n_ng-locales_sk_mjs"
		]
	],
	"./sl.mjs": [
		92702,
		[
			"src_assets_i18n_ng-locales_sl_mjs"
		]
	],
	"./smn.mjs": [
		84947,
		[
			"src_assets_i18n_ng-locales_smn_mjs"
		]
	],
	"./sn.mjs": [
		39404,
		[
			"src_assets_i18n_ng-locales_sn_mjs"
		]
	],
	"./so-DJ.mjs": [
		3628,
		[
			"src_assets_i18n_ng-locales_so-DJ_mjs"
		]
	],
	"./so-ET.mjs": [
		48745,
		[
			"src_assets_i18n_ng-locales_so-ET_mjs"
		]
	],
	"./so-KE.mjs": [
		58926,
		[
			"src_assets_i18n_ng-locales_so-KE_mjs"
		]
	],
	"./so.mjs": [
		77341,
		[
			"src_assets_i18n_ng-locales_so_mjs"
		]
	],
	"./sq-MK.mjs": [
		51948,
		[
			"src_assets_i18n_ng-locales_sq-MK_mjs"
		]
	],
	"./sq-XK.mjs": [
		5903,
		[
			"src_assets_i18n_ng-locales_sq-XK_mjs"
		]
	],
	"./sq.mjs": [
		78099,
		[
			"src_assets_i18n_ng-locales_sq_mjs"
		]
	],
	"./sr-Cyrl-BA.mjs": [
		75475,
		[
			"src_assets_i18n_ng-locales_sr-Cyrl-BA_mjs"
		]
	],
	"./sr-Cyrl-ME.mjs": [
		62594,
		[
			"src_assets_i18n_ng-locales_sr-Cyrl-ME_mjs"
		]
	],
	"./sr-Cyrl-XK.mjs": [
		20404,
		[
			"src_assets_i18n_ng-locales_sr-Cyrl-XK_mjs"
		]
	],
	"./sr-Cyrl.mjs": [
		36491,
		[
			"src_assets_i18n_ng-locales_sr-Cyrl_mjs"
		]
	],
	"./sr-Latn-BA.mjs": [
		14760,
		[
			"src_assets_i18n_ng-locales_sr-Latn-BA_mjs"
		]
	],
	"./sr-Latn-ME.mjs": [
		4949,
		[
			"src_assets_i18n_ng-locales_sr-Latn-ME_mjs"
		]
	],
	"./sr-Latn-XK.mjs": [
		46656,
		[
			"src_assets_i18n_ng-locales_sr-Latn-XK_mjs"
		]
	],
	"./sr-Latn.mjs": [
		1406,
		[
			"src_assets_i18n_ng-locales_sr-Latn_mjs"
		]
	],
	"./sr.mjs": [
		58456,
		[
			"src_assets_i18n_ng-locales_sr_mjs"
		]
	],
	"./su-Latn.mjs": [
		33495,
		[
			"src_assets_i18n_ng-locales_su-Latn_mjs"
		]
	],
	"./su.mjs": [
		17519,
		[
			"src_assets_i18n_ng-locales_su_mjs"
		]
	],
	"./sv-AX.mjs": [
		42446,
		[
			"src_assets_i18n_ng-locales_sv-AX_mjs"
		]
	],
	"./sv-FI.mjs": [
		63330,
		[
			"src_assets_i18n_ng-locales_sv-FI_mjs"
		]
	],
	"./sv.mjs": [
		53556,
		[
			"src_assets_i18n_ng-locales_sv_mjs"
		]
	],
	"./sw-CD.mjs": [
		82727,
		[
			"src_assets_i18n_ng-locales_sw-CD_mjs"
		]
	],
	"./sw-KE.mjs": [
		15142,
		[
			"src_assets_i18n_ng-locales_sw-KE_mjs"
		]
	],
	"./sw-UG.mjs": [
		52578,
		[
			"src_assets_i18n_ng-locales_sw-UG_mjs"
		]
	],
	"./sw.mjs": [
		47109,
		[
			"src_assets_i18n_ng-locales_sw_mjs"
		]
	],
	"./ta-LK.mjs": [
		44076,
		[
			"src_assets_i18n_ng-locales_ta-LK_mjs"
		]
	],
	"./ta-MY.mjs": [
		47753,
		[
			"src_assets_i18n_ng-locales_ta-MY_mjs"
		]
	],
	"./ta-SG.mjs": [
		63325,
		[
			"src_assets_i18n_ng-locales_ta-SG_mjs"
		]
	],
	"./ta.mjs": [
		82662,
		[
			"src_assets_i18n_ng-locales_ta_mjs"
		]
	],
	"./te.mjs": [
		67005,
		[
			"src_assets_i18n_ng-locales_te_mjs"
		]
	],
	"./teo-KE.mjs": [
		1286,
		[
			"src_assets_i18n_ng-locales_teo-KE_mjs"
		]
	],
	"./teo.mjs": [
		47621,
		[
			"src_assets_i18n_ng-locales_teo_mjs"
		]
	],
	"./tg.mjs": [
		10872,
		[
			"src_assets_i18n_ng-locales_tg_mjs"
		]
	],
	"./th.mjs": [
		76631,
		[
			"src_assets_i18n_ng-locales_th_mjs"
		]
	],
	"./ti-ER.mjs": [
		40434,
		[
			"src_assets_i18n_ng-locales_ti-ER_mjs"
		]
	],
	"./ti.mjs": [
		94702,
		[
			"src_assets_i18n_ng-locales_ti_mjs"
		]
	],
	"./tk.mjs": [
		25372,
		[
			"src_assets_i18n_ng-locales_tk_mjs"
		]
	],
	"./to.mjs": [
		23136,
		[
			"src_assets_i18n_ng-locales_to_mjs"
		]
	],
	"./tr-CY.mjs": [
		58202,
		[
			"src_assets_i18n_ng-locales_tr-CY_mjs"
		]
	],
	"./tr.mjs": [
		75765,
		[
			"src_assets_i18n_ng-locales_tr_mjs"
		]
	],
	"./tt.mjs": [
		7011,
		[
			"src_assets_i18n_ng-locales_tt_mjs"
		]
	],
	"./twq.mjs": [
		91781,
		[
			"src_assets_i18n_ng-locales_twq_mjs"
		]
	],
	"./tzm.mjs": [
		23794,
		[
			"src_assets_i18n_ng-locales_tzm_mjs"
		]
	],
	"./ug.mjs": [
		51655,
		[
			"src_assets_i18n_ng-locales_ug_mjs"
		]
	],
	"./uk.mjs": [
		30051,
		[
			"src_assets_i18n_ng-locales_uk_mjs"
		]
	],
	"./und.mjs": [
		8874,
		[
			"src_assets_i18n_ng-locales_und_mjs"
		]
	],
	"./ur-IN.mjs": [
		72654,
		[
			"src_assets_i18n_ng-locales_ur-IN_mjs"
		]
	],
	"./ur.mjs": [
		73778,
		[
			"src_assets_i18n_ng-locales_ur_mjs"
		]
	],
	"./uz-Arab.mjs": [
		40035,
		[
			"src_assets_i18n_ng-locales_uz-Arab_mjs"
		]
	],
	"./uz-Cyrl.mjs": [
		2761,
		[
			"src_assets_i18n_ng-locales_uz-Cyrl_mjs"
		]
	],
	"./uz-Latn.mjs": [
		75072,
		[
			"src_assets_i18n_ng-locales_uz-Latn_mjs"
		]
	],
	"./uz.mjs": [
		39274,
		[
			"src_assets_i18n_ng-locales_uz_mjs"
		]
	],
	"./vai-Latn.mjs": [
		18617,
		[
			"src_assets_i18n_ng-locales_vai-Latn_mjs"
		]
	],
	"./vai-Vaii.mjs": [
		69999,
		[
			"src_assets_i18n_ng-locales_vai-Vaii_mjs"
		]
	],
	"./vai.mjs": [
		27449,
		[
			"src_assets_i18n_ng-locales_vai_mjs"
		]
	],
	"./vi.mjs": [
		13780,
		[
			"src_assets_i18n_ng-locales_vi_mjs"
		]
	],
	"./vun.mjs": [
		72810,
		[
			"src_assets_i18n_ng-locales_vun_mjs"
		]
	],
	"./wae.mjs": [
		53216,
		[
			"src_assets_i18n_ng-locales_wae_mjs"
		]
	],
	"./wo.mjs": [
		65705,
		[
			"src_assets_i18n_ng-locales_wo_mjs"
		]
	],
	"./xh.mjs": [
		92219,
		[
			"src_assets_i18n_ng-locales_xh_mjs"
		]
	],
	"./xog.mjs": [
		97463,
		[
			"src_assets_i18n_ng-locales_xog_mjs"
		]
	],
	"./yav.mjs": [
		99377,
		[
			"src_assets_i18n_ng-locales_yav_mjs"
		]
	],
	"./yi.mjs": [
		14205,
		[
			"src_assets_i18n_ng-locales_yi_mjs"
		]
	],
	"./yo-BJ.mjs": [
		36704,
		[
			"src_assets_i18n_ng-locales_yo-BJ_mjs"
		]
	],
	"./yo.mjs": [
		45643,
		[
			"src_assets_i18n_ng-locales_yo_mjs"
		]
	],
	"./yrl-CO.mjs": [
		60185,
		[
			"src_assets_i18n_ng-locales_yrl-CO_mjs"
		]
	],
	"./yrl-VE.mjs": [
		32692,
		[
			"src_assets_i18n_ng-locales_yrl-VE_mjs"
		]
	],
	"./yrl.mjs": [
		90178,
		[
			"src_assets_i18n_ng-locales_yrl_mjs"
		]
	],
	"./yue-Hans.mjs": [
		65883,
		[
			"src_assets_i18n_ng-locales_yue-Hans_mjs"
		]
	],
	"./yue-Hant.mjs": [
		6748,
		[
			"src_assets_i18n_ng-locales_yue-Hant_mjs"
		]
	],
	"./yue.mjs": [
		77398,
		[
			"src_assets_i18n_ng-locales_yue_mjs"
		]
	],
	"./zgh.mjs": [
		62694,
		[
			"src_assets_i18n_ng-locales_zgh_mjs"
		]
	],
	"./zh-Hans-HK.mjs": [
		94796,
		[
			"src_assets_i18n_ng-locales_zh-Hans-HK_mjs"
		]
	],
	"./zh-Hans-MO.mjs": [
		5987,
		[
			"src_assets_i18n_ng-locales_zh-Hans-MO_mjs"
		]
	],
	"./zh-Hans-SG.mjs": [
		55033,
		[
			"src_assets_i18n_ng-locales_zh-Hans-SG_mjs"
		]
	],
	"./zh-Hans.mjs": [
		55082,
		[
			"src_assets_i18n_ng-locales_zh-Hans_mjs"
		]
	],
	"./zh-Hant-HK.mjs": [
		34985,
		[
			"src_assets_i18n_ng-locales_zh-Hant-HK_mjs"
		]
	],
	"./zh-Hant-MO.mjs": [
		79682,
		[
			"src_assets_i18n_ng-locales_zh-Hant-MO_mjs"
		]
	],
	"./zh-Hant.mjs": [
		81573,
		[
			"src_assets_i18n_ng-locales_zh-Hant_mjs"
		]
	],
	"./zh.mjs": [
		99257,
		[
			"src_assets_i18n_ng-locales_zh_mjs"
		]
	],
	"./zu.mjs": [
		63884,
		[
			"src_assets_i18n_ng-locales_zu_mjs"
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 51245;
module.exports = webpackAsyncContext;